import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoadingStatus } from '../../types/profile';
import {
  JobsiteLocationPreference,
  UserPreferenceDataLoadPayload,
  UserPreferenceDataUpdatePayload,
  UserPreferencesState,
} from '../../types/user-preferences';

const initialState: UserPreferencesState = {
  jobsiteLocation: {
    data: null,
    loadingStatus: LoadingStatus.UNSET,
  },
};

export const userPreferencesSlice = createSlice({
  name: 'userPreferences',
  initialState,
  reducers: {
    setJobsiteLocationPreference: (state, action: PayloadAction<JobsiteLocationPreference>) => {
      state.jobsiteLocation.data = action.payload;
      state.jobsiteLocation.loadingStatus = LoadingStatus.SUCCEEDED;
    },
    setJobsiteLocationPreferenceLoadingStatus: (state, action: PayloadAction<LoadingStatus>) => {
      state.jobsiteLocation.loadingStatus = action.payload;
    },
  },
});

export const { setJobsiteLocationPreference, setJobsiteLocationPreferenceLoadingStatus } =
  userPreferencesSlice.actions;

export const loadJobsiteLocationPreference = createAction<UserPreferenceDataLoadPayload>(
  'userPreferences/loadJobsiteLocationPreference',
);

export const updateJobsiteLocationPreference = createAction<UserPreferenceDataUpdatePayload>(
  'userPreferences/updateJobsiteLocationPreference',
);

export default userPreferencesSlice.reducer;
